import React, { useEffect, useState } from "react";
import { useAtedimento } from "../../../../Context/Atendimento";

import {
    faCheckCircle,
    faDice,
    faExchangeAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ClickAwayListener } from "@material-ui/core";

import { DadosContato } from "../DadosContato";

import { fullFormatPhone, formatPhone } from "../../../../Tools/FormatTools";
import { IMensagem } from "../../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { FinalizarAtendimentoController } from "../../../../Controllers/HelpDesk/Atendimento/AtendimentoControllers";
import ModalComponent from "../../../../Components/Modais";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import Transferir from "./Transferir";

import Swal from "sweetalert2";
import "./styles.css";
import ConversaMensagens from "./ConversaMensagens";
import EnviarMensagem from "./EnviarMensagem";
import WhatsappAtivo, {
    InforWhatsappSend,
} from "./../../../../Components/Utils/WhatsappAtivo/index";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { useUserInfor } from "../../../../Context/User";
import { GetInfoContatoController } from "../../../../Controllers/Geral/Contatos/ContatosController";
import { IContatoComConta } from "../../../../Interfaces/Geral/Contatos/ContatosInterfaces";

interface IConversaProps {
    getMensagensContaChatHistorico: (
        nrTelefone: string
    ) => Promise<Array<IMensagem>>;
}

export function Conversa(props: IConversaProps) {
    const [showOffCanvas, setShowOffCanvas] = useState<"dados" | "chats" | "">(
        ""
    );
    const { UserInfor } = useUserInfor();

    const [showModal, setShowModal] = useState(false);
    const [Modal, setModal] = useState<IComponentModal>({} as IComponentModal);

    const { chatAberto, setChatAberto } = useAtedimento().HELP_DESK;
    const [loading, setLoading] = useState(false);
    const [contato, setContato] = useState<IContatoComConta | undefined>(
        {} as IContatoComConta
    );

    useEffect(() => {
        if (chatAberto?.IdConta) {
            setLoading(true);
            GetInfoContatoController(chatAberto.NumeroCliente).then((res) => {
                setLoading(false);
                setContato(res);
            });
        } else {
            setContato(undefined);
        }
    }, [chatAberto?.IdConta, chatAberto?.NumeroCliente]);

    return (
        <>
            <div className="card card-custom justify-content-between controlledHeightDiv">
                <div className="card-header flex-nowrap align-items-center px-4 py-3">
                    <div className="text-left flex-grow-1">
                        <div className="text-dark-75 font-weight-bold font-size-h5">
                                {loading ? 'Carregando...' : contato?.CONTATO?.DS_NOME ||
                                fullFormatPhone(
                                    chatAberto?.NumeroCliente || ""
                                )}
                            {UserInfor.FUNCOES.some(
                                (f) => f.NM_FUNCAO === "WHATS_MENSAGEM_ATIVA"
                            ) &&
                                chatAberto?.NumeroCliente && (
                                    <span className="m-2">
                                        <WhatsappAtivo
                                            onClick={() => {
                                                setShowModal(true);
                                                setModal({
                                                    headerComponent:
                                                        "Enviar mensagem!",
                                                    IconHeader: faWhatsapp,
                                                    size: "lg",
                                                    Component: () => (
                                                        <InforWhatsappSend
                                                            lstContatos={[
                                                                `${chatAberto?.NumeroCliente.replace(
                                                                    "whatsapp:+55",
                                                                    ""
                                                                )}`,
                                                            ]}
                                                            setModal={
                                                                setShowModal
                                                            }
                                                        />
                                                    ),
                                                });
                                            }}
                                        />
                                    </span>
                                )}
                        </div>
                        {(chatAberto?.NomeCliente ||
                            chatAberto?.ProfileName) && (
                            <span className="text-muted">
                                {chatAberto?.NomeCliente ||
                                    fullFormatPhone(
                                        chatAberto?.NumeroCliente || ""
                                    ) ||
                                    ""}
                            </span>
                        )}
                    </div>
                    <div className="text-right flex-grow-1">
                        <button
                            type="button"
                            className="btn btn-clean btn-sm btn-icon btn-icon-md d-lg-none"
                            id="kt_app_chat_toggle"
                            data-toggle="collapse"
                            data-target="#collapseChatInMobile"
                            aria-expanded="false"
                            aria-controls="collapseChatInMobile"
                        >
                            <span className="svg-icon svg-icon-lg">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 24 24"
                                    version="1.1"
                                >
                                    <g
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                    >
                                        <rect
                                            x="0"
                                            y="0"
                                            width="24"
                                            height="24"
                                        ></rect>
                                        <path
                                            d="M18,2 L20,2 C21.6568542,2 23,3.34314575 23,5 L23,19 C23,20.6568542 21.6568542,22 20,22 L18,22 L18,2 Z"
                                            fill="#000000"
                                            opacity="0.3"
                                        ></path>
                                        <path
                                            d="M5,2 L17,2 C18.6568542,2 20,3.34314575 20,5 L20,19 C20,20.6568542 18.6568542,22 17,22 L5,22 C4.44771525,22 4,21.5522847 4,21 L4,3 C4,2.44771525 4.44771525,2 5,2 Z M12,11 C13.1045695,11 14,10.1045695 14,9 C14,7.8954305 13.1045695,7 12,7 C10.8954305,7 10,7.8954305 10,9 C10,10.1045695 10.8954305,11 12,11 Z M7.00036205,16.4995035 C6.98863236,16.6619875 7.26484009,17 7.4041679,17 C11.463736,17 14.5228466,17 16.5815,17 C16.9988413,17 17.0053266,16.6221713 16.9988413,16.5 C16.8360465,13.4332455 14.6506758,12 11.9907452,12 C9.36772908,12 7.21569918,13.5165724 7.00036205,16.4995035 Z"
                                            fill="#000000"
                                        ></path>
                                    </g>
                                </svg>
                            </span>
                        </button>
                        {chatAberto && (
                            <div className="dropdown dropleft">
                                <button
                                    type="button"
                                    className="btn btn-clean btn-sm btn-icon btn-icon-md"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <i className="ki ki-bold-more-hor icon-md"></i>
                                </button>
                                <div className="dropdown-menu p-0 m-0 dropdown-menu-md">
                                    <ul className="navi navi-hover py-5">
                                        <li className="navi-item" role="button">
                                            <span
                                                className="navi-link"
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: "Finalizar Atendimento?",
                                                        icon: "success",
                                                        buttonsStyling: false,
                                                        confirmButtonText:
                                                            "<i class='la la-check'></i> Sim!",
                                                        showCancelButton: true,
                                                        cancelButtonText:
                                                            "<i class='la la-thumbs-down'></i> Não",
                                                        customClass: {
                                                            confirmButton:
                                                                "btn btn-outline-success",
                                                            cancelButton:
                                                                "btn btn-default",
                                                        },
                                                    }).then((result) => {
                                                        /* Read more about isConfirmed, isDenied below */
                                                        if (
                                                            result.isConfirmed
                                                        ) {
                                                            FinalizarAtendimentoController(
                                                                formatPhone(
                                                                    chatAberto.NumeroCliente
                                                                )
                                                            ).then(() => {
                                                                setChatAberto();
                                                            });
                                                        }
                                                    });
                                                }}
                                            >
                                                <span className="navi-icon">
                                                    <FontAwesomeIcon
                                                        icon={faCheckCircle}
                                                    />
                                                </span>
                                                <span className="navi-text">
                                                    Finalizar
                                                </span>
                                            </span>
                                        </li>
                                        <li className="navi-item" role="button">
                                            <span
                                                className="navi-link"
                                                onClick={() => {
                                                    setModal({
                                                        Component: () =>
                                                            Transferir({
                                                                setShow:
                                                                    setShowModal,
                                                            }),
                                                        headerComponent:
                                                            "Transferir",
                                                        IconHeader:
                                                            faExchangeAlt,
                                                    });
                                                    setShowModal(true);
                                                }}
                                            >
                                                <span className="navi-icon">
                                                    <FontAwesomeIcon
                                                        icon={faExchangeAlt}
                                                    />
                                                </span>
                                                <span className="navi-text">
                                                    Transferir
                                                </span>
                                            </span>
                                        </li>
                                        <li className="navi-item" role="button">
                                            <span
                                                className="navi-link"
                                                onClick={() => {
                                                    setShowOffCanvas("dados");
                                                }}
                                            >
                                                <span className="navi-icon">
                                                    <FontAwesomeIcon
                                                        icon={faDice}
                                                    />
                                                </span>
                                                <span className="navi-text">
                                                    Dados do Contato
                                                </span>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <ConversaMensagens
                    getMensagensContaChatHistorico={
                        props.getMensagensContaChatHistorico
                    }
                />
                <EnviarMensagem />
            </div>
            <ClickAwayListener
                mouseEvent="onMouseDown"
                touchEvent="onTouchEnd"
                onClickAway={() => {
                    setShowOffCanvas("");
                }}
            >
                <div
                    id="kt_demo_panel"
                    className={`offcanvas offcanvas-right p-10 ${
                        showOffCanvas === "dados" ? "offcanvas-on" : ""
                    }`}
                >
                    <div
                        className="offcanvas-header d-flex align-items-center justify-content-between pb-7"
                        kt-hidden-height="47"
                    >
                        <h4 className="font-weight-bold m-0">Dados Contatos</h4>
                        <button
                            className="btn btn-xs btn-icon btn-light btn-hover-primary"
                            id="kt_demo_panel_close"
                            onClick={() => {
                                setShowOffCanvas("");
                            }}
                        >
                            <i className="ki ki-close icon-xs text-muted"></i>
                        </button>
                    </div>
                    <div className="offcanvas-content dados-contato-offcanvas y-scroll">
                        <DadosContato />
                    </div>
                </div>
            </ClickAwayListener>

            <ModalComponent
                show={showModal}
                setShow={setShowModal}
                ModalComponent={Modal}
            />
        </>
    );
}
